export default __webpack_public_path__ + "images/dd21ca8b725f8922746d4553facf18b5.png";